"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphirePoolFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphirePoolFactory = /** @class */ (function (_super) {
    __extends(MockSapphirePoolFactory, _super);
    function MockSapphirePoolFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphirePoolFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphirePoolFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphirePoolFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphirePoolFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphirePoolFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphirePoolFactory;
}(contracts_1.ContractFactory));
exports.MockSapphirePoolFactory = MockSapphirePoolFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "CoreBorrowLimitSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "DepositLimitSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amountDecreased",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newStablesLentAmount",
                type: "uint256",
            },
        ],
        name: "StablesLentDecreased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_stablecoin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_borrowedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
        ],
        name: "TokensBorrowed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_depositAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_lpTokensAmount",
                type: "uint256",
            },
        ],
        name: "TokensDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_core",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_stablecoin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_repaidAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_debtRepaid",
                type: "uint256",
            },
        ],
        name: "TokensRepaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_lpAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_withdrawAmount",
                type: "uint256",
            },
        ],
        name: "TokensWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedRewardAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
        ],
        name: "assetDepositUtilization",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amountUsed",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "limit",
                        type: "uint256",
                    },
                ],
                internalType: "struct SharedPoolStructs.AssetUtilization",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stablecoinAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_scaledBorrowAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
        ],
        name: "borrow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_coreAddress",
                type: "address",
            },
        ],
        name: "coreBorrowUtilization",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amountUsed",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "limit",
                        type: "uint256",
                    },
                ],
                internalType: "struct SharedPoolStructs.AssetUtilization",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_debtDecreaseAmount",
                type: "uint256",
            },
        ],
        name: "decreaseStablesLent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_userAddress",
                type: "address",
            },
        ],
        name: "deposits",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getDepositAssets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPoolValue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_decimalsIn",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "_decimalsOut",
                type: "uint8",
            },
        ],
        name: "getScaledAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stablecoinAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_repayAmount",
                type: "uint256",
            },
        ],
        name: "repay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_coreAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "setCoreBorrowLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "setDepositLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stablesLent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "tokenDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lpAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_withdrawToken",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
